import script from "./payroll-meta-conversion.vue?vue&type=script&setup=true&lang=js"
export * from "./payroll-meta-conversion.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__